import {put,takeLatest,call} from 'redux-saga/effects';
import * as searcService from "../../../services/searchService";
import {
    GET_VENUES_WITHINRANGE,
    GET_VENUES_WITHINRANGE_SUCCESS,
    GET_VENUES_WITHINRANGE_ERROR
}
    from "../../actions/venue";

function* getVenuesWithInRangeSaga(action) {
    try {
        const data=yield call(searcService.GetVenuesWithInRange,action.payload)
        yield put({
            type: GET_VENUES_WITHINRANGE_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_VENUES_WITHINRANGE_ERROR,error: error.data ? error.data : error
        });
    }
}


export function* getVenuesWithInRangeSagaWatcher() {
    yield takeLatest(GET_VENUES_WITHINRANGE,getVenuesWithInRangeSaga);
}